import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { strategiesApi } from "src/api";
import { CreateStrategyParams, DcaExampleType, StrategyKey, StrategyType, TradeDirection } from "src/api/types";
import CButton from "src/component/CButton/CButton";
import CSelect from "src/component/CSelect";
import { useExchangeInfoStore } from "src/store";
import { getPairName } from "src/store/utils";
import * as Yup from "yup";
import styles from "./index.module.scss";
import { useState } from "react";
import { useExchangeAccounts } from "src/hook/useExchangeAccounts";
import React from "react";
import CommonDcaForm from "src/component/StrategyForms/CommonDcaForm";
import CSwitch from "src/component/CSwitch/CSwitch";

export default function DcaForm() {
  const store = useExchangeInfoStore();
  const exchanges = useExchangeAccounts();
  const [selectedExchangeAccountId, setSelectedExchangeAccountId] = useState<number | null>(null);

  const exchangeAccountOptions = exchanges.myExchangeAccounts.map((account) => {
    const exchange = store.exchanges.find((exchange) => exchange.id === account.exchangeId);
    const displayName = `${exchange ? exchange.name : "unknown"}: ${account.alias}`;
    return { value: account.id, label: displayName };
  });

  const pairOptions = store.spotPairs.map((pair) => ({
    value: pair.id,
    label: getPairName(pair.base, pair.quote),
  }));
  const intervalOptions = [
    { value: "1m", label: "1m" },
    { value: "5m", label: "5m" },
    { value: "15m", label: "15m" },
    { value: "30m", label: "30m" },
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  return (
    <Formik
      initialValues={{
        strategyName: "",
        pair: "",
        exchangeAccount: "",
        repeatIntervalMsMin: "10000",
        repeatIntervalMsMax: "20000",

        // priceLow7: number;
        // priceHigh7: number;
        // firstPrice7: number;
        // priceGap7: number;
        // orderNum7: number;
        // totalAmount7: number;
        // profitGap7: number;
        // stopAndSell7: number;
        // sellOrderNum7: number;
        // sellInterval7: number;
        priceLow7: "",
        priceHigh7: "",
        firstPrice7: "",
        priceGap7: "",
        orderNum7: "",
        totalAmount7: "",
        profitGap7: "",
        stopAndSell7: false,
        profitAlone: false,
        sellOrderNum7: "",
        sellInterval7: "",
      }}
      validationSchema={Yup.object({
        pair: Yup.object().required("Required"),
        exchangeAccount: Yup.object().required("Required"),
        
      })}
      onSubmit={async (values) => {
        const payload: CreateStrategyParams<DcaExampleType> = {
          strategyName: values.strategyName,
          pairId: Number((values.pair as any).value),
          exchangeAccountId: Number((values.exchangeAccount as any).value),
          type: StrategyType.Dca,
          repeatIntervalMsMin: Number(values.repeatIntervalMsMin),
          repeatIntervalMsMax: Number(values.repeatIntervalMsMax),
          preference: {
            priceLow7: Number(values.priceLow7),
            priceHigh7: Number(values.priceHigh7),
            firstPrice7: Number(values.firstPrice7),
            priceGap7: Number(values.priceGap7),
            orderNum7: Number(values.orderNum7),
            totalAmount7: Number(values.totalAmount7),
            profitGap7: Number(values.profitGap7),
            stopAndSell7: values.stopAndSell7,
            profitAlone: values.profitAlone,
            sellOrderNum7: Number(values.sellOrderNum7),
            sellInterval7: Number(values.sellInterval7),
          },
        };
        console.log("payload", payload);

        try {
          const result = await strategiesApi.createStrategyV2(payload);
          window.location.href = `/strategies?tab=${StrategyKey.Dca}`;
        } catch (error) {
          alert("创建失败");
        }
      }}
    >
      {({ values, setFieldValue, submitForm }) => {
        return (
          <>
            <Form className={styles.form}>
              <Flex width="calc(100% - 20px)" flexDirection="column" gap={2}>
                <Flex alignItems="center" gap={2} mt={4}>
                  <CSelect
                    classname={styles.select}
                    label={"交易所账户"}
                    placeholder="交易所账户"
                    options={exchangeAccountOptions}
                    onChange={(value) => {
                      setFieldValue("exchangeAccount", value);
                      setSelectedExchangeAccountId((value as any).value);
                    }}
                  />
                </Flex>
                <Flex alignItems="center" gap={2} mt={2}>
                  <CSelect
                    classname={styles.select}
                    label={"交易对"}
                    placeholder="交易对"
                    options={pairOptions}
                    onChange={(value) => {
                      setFieldValue("pair", value);
                    }}
                  />
                </Flex>
                <CommonDcaForm styles={styles} />
                <CSwitch
                  classname={styles.select}
                  label={"停止时卖出"}
                  onChange={(_, value) => {
                    setFieldValue("stopAndSell7", value);
                  }}
                  isChecked={values.stopAndSell7}
                  name="stopAndSell7"
                />
                <CSwitch
                  classname={styles.select}
                  label={"止盈是否独立"}
                  onChange={(_, value) => {
                    setFieldValue("profitAlone", value);
                  }}
                  isChecked={values.profitAlone}
                  name="profitAlone"
                  description="每一笔DCA订单的止盈是否独立计算，如果是true，会自动卖出"
                />

                <Flex alignItems="center" gap={2} mt={4}>
                  <CButton name="确认创建" onClick={onOpen} />
                </Flex>
              </Flex>
            </Form>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    确认创建
                  </AlertDialogHeader>

                  <AlertDialogBody>确定立即创建机器人吗？</AlertDialogBody>

                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                      取消
                    </Button>
                    <Button
                      onClick={() => {
                        onClose();
                        submitForm();
                      }}
                      ml={3}
                    >
                      确定
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </>
        );
      }}
    </Formik>
  );
}
